export const socketURL = process.env.NODE_ENV === 'production' ? 'avalon-game.com' : 'localhost:3000';
